
/* injects from baggage-loader */

'use strict';

import AdminHomeController from './admin.home.controller';
import AdminHomeTemplate from './admin.home.html';

export default class AdminHomeComponent {
		constructor() {
				this.templateUrl = AdminHomeTemplate;
				this.controller = AdminHomeController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/home/admin.home.component.js